import { CancelMembershipAction, CancelMembershipActionType } from './cancelmembershipActionType';
import { ICancelMembershipState } from './cancelMemberState';

export function cancelMembershipReducer(
    state: ICancelMembershipState = {
        cancelMembershipOverlayOpen: false,
        deletingAccount: false,
        deleteAccountError: null,
    },
    action: CancelMembershipAction,
) {
    switch (action.type) {
        case CancelMembershipActionType.CLOSE_CANCEL_MEMBERSHIP_OVERLAY:
            return {
                ...state,
                cancelMembershipOverlayOpen: false,
            };
        case CancelMembershipActionType.OPEN_CANCEL_MEMBERSHIP_OVERLAY:
            return {
                ...state,
                cancelMembershipOverlayOpen: true,
            };
        case CancelMembershipActionType.CANCEL_MEMBERSHIP_REQUEST:
            return {
                ...state,
                deletingAccount: true,
            };
        case CancelMembershipActionType.CANCEL_MEMBERSHIP_SUCCESS:
            return {
                ...state,
            };
        case CancelMembershipActionType.CANCEL_MEMBERSHIP_FAILURE:
            const payload = action.payload;
            return {
                ...state,
                deleteAccountError: payload.errorResolution,
                deletingAccount: false,
            };
        default:
            return state;
    }
}
